<script>
import {ref, provide, toRef} from 'vue';
import AkSelect from '@components/v2/input/AkSelect.vue';
import Dropdown from 'primevue/dropdown';

export default {
  name: 'IndicatorGroup',
  components: {AkSelect, Dropdown},
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    interval: {
      type: String,
      required: true,
    },
  },
  emits: ['update:interval'],
  setup(props, {emit}) {
    let displayMode = ref('card');
    let intervalProvide = toRef(props, 'interval');

    const refresh = (newValue) => {
      emit('update:interval', newValue);
    };

    provide('displayMode', displayMode);
    provide('interval', intervalProvide);
    provide('refresh', refresh);

    return {displayMode, intervalProvide};
  },
  data() {
    return {
      displayModeValue: 'card',
      displayOptions: [
        {label: 'Carte', icon: 'ga-icon ga-t4', value: 'card'},
        {label: 'Graphique', icon: 'ga-icon ga-trend_up', value: 'graph'},
      ],
      intervalOptions: [
        {label: 'Jour', value: 'daily'},
        {label: 'Semaine', value: 'weekly'},
        {label: 'Mois', value: 'monthly'},
        {label: 'Année', value: 'yearly'},
      ],
    };
  },
  computed: {
    intervalValue: {
      get() {
        return this.interval;
      },
      set(value) {
        this.$emit('update:interval', value);
      },
    },
    isGraph() {
      return this.displayModeValue === 'graph';
    },
    showToggle() {
      return import.meta.env.VUE_APP_RM_STATS_GRAPH === 'true';
    },
  },
  watch: {
    displayModeValue(newVal) {
      this.displayMode = newVal;
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex justify-between">
      <span class="flex h-fit items-center gap-3 text-grey-900 text-3xl font-bold">
        <i class="ga-icon text-[32px]" :class="icon" />
        {{ label }}
      </span>
      <div class="flex flex-col gap-4 items-end">
        <AkSelect v-if="showToggle" v-model="displayModeValue" :options="displayOptions" mobile-no-label />
        <Dropdown
          v-if="isGraph"
          :options="intervalOptions"
          v-model="intervalValue"
          class="border rounded-md border-grey-100 bg-transparent w-fit h-[48px] pl-4 pr-2 flex items-center hover:!bg-grey-50 hover:!border-grey-200 transition-none [&.p-focus]:border-grey-100 [&.p-focus]:bg-transparent"
          option-label="label"
          option-value="value">
          <template #value> Visualisation </template>
        </Dropdown>
      </div>
    </div>
    <div class="flex flex-col gap-8">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<style scoped></style>
